import { forwardRef } from "react";
import clsx from "clsx";

import styles from "./FreeTrialCard.module.css";
import { getPeriodString } from "../../lib/helpers/dateHelper";
import { PaymentData } from "../../lib/types";

type Props = {
  paymentData: PaymentData;
};
const PaymentCard = forwardRef<HTMLDivElement, Props>(
  ({ paymentData }, ref) => {
    return (
      <div className={styles.cardNoTrial} ref={ref}>
        <div>
          <h3 className={clsx(styles.cardHeader, "semibold")}>Your Plan</h3>
        </div>

        <div className={styles.priceCardNoTrial}>
          <dl>
            <dt className="body-md">
              <span>
                  {`${getPeriodString(paymentData.period)?.adjective} Plan`}
              </span>
            </dt>
            <dd className="body-md">
                $13/mo billed yearly
            </dd>
          </dl>
        </div>
      </div>
    );
  }
);

export default PaymentCard;
